export default "__VITE_ASSET__DDAsurkE__"